<template>
  <!-- 由于数据层级过多，vue无法捕获数据，无法正常显示，所以添加一个组件来操作 -->
  <div class="setting-domain" v-if="showData">
    <system-setting-data :setting="setting" @change="save"/>
    <div v-for="(item, idx) in children" :key="item.id">
      <system-setting-data :setting="item" @change="save">
        <template #default>
          <page-button v-if="showCallBackBtn && idx === children.length - 1" el-type="primary" @click="toCallBack">保存变更</page-button>
        </template>
      </system-setting-data>
    </div>
  </div>
</template>

<script>
import systemSettingApi from "@/api/normal/sys/systemSettingApi";
import SystemSettingData from "@/views/h5/common/basedata/setting/SystemSettingData.vue";
import {watch} from "vue";
export default {
  emits: ["update"],
  props: {
    setting: {default: () => {
        return {
          settingDataType: 0,
          settingValue: "0",
          settingRemark: [],
          settingName: "",
          settingDescription: "",
          settingParams: "",
        };
      }
    },
    settingList: {default: () => []}
  },
  name: "SystemComponent",
  components: {
    SystemSettingData
  },
  data() {
    return {
      showData: true, // 是否显示这条数据
      children: [],
      showCallBackBtn: false,
      callBackInterface: "",
    };
  },
  created() {
    this.init();
    watch(() => this.setting, () =>{
      this.init();
    }, {deep: true})
  },
  methods: {
    init() {
      if (this.setting.condition) {
        this.showData = false; // 不显示condition
      }
      if (this.setting.settingDataType === 2 || this.setting.settingDataType === 3) {
        this.optionList = JSON.parse(this.setting.settingParams);
        // 如果有回调函数
        if (this.optionList && this.optionList.length > 0) {
          for (let i = 0; i < this.optionList.length; i++) {
            if(this.optionList[i].code === this.setting.settingValue && this.optionList[i].callBack) {
              this.showCallBackBtn = true;
              this.callBackInterface = this.optionList[i].callBack;
            }
          }
        }
      }
      // 从list中找到condition是这条数据的配置，将数据添加为子级数据
      let arr = [];
      for (let i = 0; i < this.settingList.length; i++) {
        let item = this.settingList[i];
        if (item.condition) {
          // 找到condition的条件
          let condition = item.condition.split("=");
          if (condition.length === 2 && condition[0] === this.setting.settingCode && condition[1] === this.setting.settingValue) {
            arr.push(item);
          }
        }
      }
      this.children = arr;
    },
    save(setting) {
      systemSettingApi.saveSetting({
        id: setting.id,
        settingValue: setting.settingValue,
        settingCode: setting.settingCode,
        settingDataType: setting.settingDataType,
        settingParams: setting.settingParams || "",
        settingCallback: setting.settingCallback || "",
      }).then(() => {
        this.$emit("update");
      });
    },
    // 回调
    toCallBack() {
      systemSettingApi.settingCallback(this.callBackInterface, this.children).then(() => {
        this.$emit("update");
      })
    }
  }
};
</script>

<style lang="scss" scoped>

</style>